import { FETCH_ALL_UNIT_OF_MEASURES, FETCH_PAGINATE_UNIT_OF_MEASURES, FETCH_CURRENT_UNIT_OF_MEASURES } from './../../mutation-types';

export default {
  [FETCH_ALL_UNIT_OF_MEASURES](state, unitOfMeasures) {
    state.all = unitOfMeasures;
  },

  [FETCH_PAGINATE_UNIT_OF_MEASURES](state, { unitOfMeasures, pagination }) {
    state.items = unitOfMeasures;
    state.pagination = pagination;
  },

  [FETCH_CURRENT_UNIT_OF_MEASURES](state, unitOfMeasure) {
    state.currentUnitOfMeasure = unitOfMeasure;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/unitOfMeasure/mutations.js